import { Directory } from "../filesystem";

export function getPathFromRoot(dir: Directory): string[] {
    const path: string[] = [];
    let current: Directory | undefined = dir;

    while (current && current.name !== "/") {
        path.unshift(current.name);
        current = current.parent;
    }

    if (path[0] === "files") path[0] = "~";
    return path;
}